import React from 'react';
import { DataGrid, Column, } from 'devextreme-react/data-grid';

export default function AvgTable(props) {

  const formatYear = (cellInfo) => {
    return cellInfo.value.getFullYear().toString()
  }

  const formatNumber = (cellInfo) => {
    if (cellInfo.value === 0) {
      return "0"
    }
    if (cellInfo.value > 1000) {
      return cellInfo.value.toFixed(0)
    }
    if (cellInfo.value > 100) {
      return cellInfo.value.toFixed(1)
    }
    if (cellInfo.value > 10) {
      return cellInfo.value.toFixed(2)
    }
    if (cellInfo.value > 1) {
      return cellInfo.value.toFixed(3)
    }
    return cellInfo.value.toFixed(4)
  }

  return (
    <div>

      {props.data &&
        <DataGrid id="dataGrid"
          dataSource={props.data}
          columnHidingEnabled={true}
          cellHintEnabled={true}
          wordWrapEnabled={true}
        >
          <Column
            dataField={'date'}
            caption={'Year'}
            dataType="date"
            defaultSortOrder="desc"
            visibleIndex={1}
            width="80px"
            customizeText={formatYear}
          >
          </Column>
          <Column
            dataField={'avg'}
            caption={'Average'}
            visibleIndex={2}
            customizeText={formatNumber}
            width="120px"
            hidingPriority={4}
          />
          <Column
            dataField={'q25'}
            caption={'1st Quartile'}
            visibleIndex={3}
            customizeText={formatNumber}
            width="120px"
            hidingPriority={3}
          />
          <Column
            dataField={'q50'}
            caption={'2st Quartile'}
            visibleIndex={4}
            customizeText={formatNumber}
            width="120px"
            hidingPriority={2}
          />
          <Column
            dataField={'q75'}
            caption={'3st Quartile'}
            visibleIndex={5}
            customizeText={formatNumber}
            width="120px"
            hidingPriority={1}
          />
        </DataGrid>
      }
    </div>
  );
}
